import React from 'react';
import PropTypes from 'prop-types';

const Payout = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.9">
      <path
        d="M19.1546 11.9058V16.7535C19.1546 18.085 18.0735 19.166 16.7421 19.166H16.1162C16.6966 19.166 16.7421 17.516 16.7421 16.7535V14.3183C16.7421 13.6582 17.0152 13.0551 17.4476 12.6113C17.8801 12.1789 18.4832 11.9058 19.1546 11.9058Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.07055 0.844727C8.07055 2.17615 6.98948 3.25723 5.65805 3.25723H3.24555V3.63276C3.24555 3.63276 3.10899 0.844727 3.86006 0.844727H8.07055Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.1162 19.1695H0.833252V3.26065C0.833252 1.92922 1.91433 0.848145 3.24575 0.848145H3.86026C3.1092 0.848145 3.24575 3.63618 3.24575 3.63618V16.757H16.7421C16.7421 17.5194 16.6966 19.1695 16.1162 19.1695Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M19.2001 2.1194V9.50484C18.5401 9.50484 17.9369 9.23173 17.4931 8.7993C17.0607 8.36687 16.7876 7.76375 16.7876 7.09234V3.25738H12.2698L12.2015 3.23462L10.836 1.86905C10.1532 1.18626 10.6425 0.924532 10.7905 0.856253C10.8018 0.856253 10.8246 0.844873 10.8474 0.844873C10.9384 0.833493 11.0181 0.833496 11.1091 0.833496H17.9142C18.6311 0.844876 19.2001 1.42524 19.2001 2.1194Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M10.8472 0.856445C10.8358 0.867804 10.8245 0.867805 10.8018 0.867805C10.8358 0.867805 10.8472 0.856445 10.8472 0.856445Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M13.308 4.22769L13.2937 4.21338C13.2937 4.22769 13.2937 4.22769 13.308 4.22769Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M10.8131 0.878868L10.0962 1.12922L10.3693 2.02822L11.4162 3.7238L12.2128 3.24585L14.9212 3.25723V0.844727L10.8131 0.878868Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M14.409 7.24032L8.92396 12.7253C7.97945 11.7808 7.97945 10.2559 8.92396 9.31143L11.9055 6.32994L9.70916 4.13366C9.1288 3.55329 8.98086 2.68843 9.33364 1.94875C9.50433 1.59598 9.77744 1.31149 10.1075 1.11803C10.3237 0.992854 10.574 0.901815 10.8244 0.867676C10.6651 0.935954 10.1871 1.19769 10.8699 1.88047L12.2355 3.24604L12.3037 3.2688H12.2241L14.409 5.4537C14.9097 5.94303 14.9097 6.75099 14.409 7.24032Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
  </svg>
);

Payout.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Payout;
